module.exports = __webpack_public_path__ + "static/media/offers-selected.775f6f2b.svg";